import PropTypes from 'prop-types'
import { useCallback, useEffect, useState } from 'react'
import { useDropzoneUpload } from '../hooks/useDropzoneUpload'
import * as archivoService from '../servicios/archivoAdjuntoService'

const ADJUNTO_TYC = 8

const UploadArchivo = ({ idUsuario, accept, idTipo }) => {
  const [adjunto, setAdjunto] = useState({ nombre: '' })

  const obtenerAdjunto = useCallback(async () => {
    const { data } = await archivoService.buscarAdjuntos(idUsuario, ADJUNTO_TYC)
    setAdjunto({ nombre: data?.nombre ?? '' })
  }, [idUsuario])

  useEffect(() => {
    obtenerAdjunto()
  }, [obtenerAdjunto])

  const buildFormData = useCallback(
    (archivo) => {
      const archivoTyc = new FormData()
      archivoTyc.append('nombre', archivo.name)
      archivoTyc.append('idUsuario', idUsuario)
      archivoTyc.append('archivo', archivo)
      archivoTyc.append('idTipo', idTipo)
      archivoTyc.append('idPath', String(idUsuario))
      return archivoTyc
    },
    [idUsuario, idTipo]
  )

  const { getRootProps, getInputProps } = useDropzoneUpload({
    accept,
    buildFormData,
    uploadFn: archivoService.subirArchivo,
    onSuccess: (archivo) => setAdjunto({ nombre: archivo.name })
  })

  return (
    <>
      <div className="borde-hormiga tyc-upload-box text-center" {...getRootProps()}>
        <input {...getInputProps()} />
        <div className="row-img-subida contenedor-cont-img-subida-perfil">
          <div className="row">
            <div className="col-6 col-xl-3">
              <div className="row">
                <div className="col-12">
                  <i className="fa fa-file fa-2x"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p>
          {adjunto.nombre ? `Archivo cargado: ${adjunto.nombre}` : 'No se encontró ningún archivo'}
        </p>
        <p>
          Hacé click para cargar tus TyC <b>en formato PDF</b>, o arrastrá el archivo desde tu
          computadora y soltalo.
        </p>
      </div>
    </>
  )
}

UploadArchivo.propTypes = {
  idUsuario: PropTypes.number.isRequired,
  accept: PropTypes.object.isRequired,
  idTipo: PropTypes.number.isRequired
}

export default UploadArchivo
